import { render, staticRenderFns } from "./DefaultShowResultsEntry.vue?vue&type=template&id=0ffb450a"
import script from "./DefaultShowResultsEntry.vue?vue&type=script&lang=ts"
export * from "./DefaultShowResultsEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports